import Glyph from 'kepler/lib/components/Glyph'

export default Glyph
